/* Nooryx theme scripts. No dependencies. */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) {
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* ---------- Carousels ---------- */
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-carousel]').forEach(function (carousel) {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      var track = carousel.querySelector('[data-carousel-track]');
      var section = carousel.closest('section') || document;
      var prev = section.querySelector('[data-carousel-prev]');
      var next = section.querySelector('[data-carousel-next]');
      if (!track) return;

      function step() {
        var slide = track.querySelector('.carousel__slide');
        if (!slide) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return slide.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var pos = Math.abs(track.scrollLeft);
        if (prev) prev.disabled = pos <= 2;
        if (next) next.disabled = pos >= max;
      }
      function go(dir) {
        var rtl = getComputedStyle(track).direction === 'rtl';
        track.scrollBy({ left: dir * step() * (rtl ? -1 : 1), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var wrap = (minus || plus).closest('[data-quantity]');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var min = parseInt(input.min || '0', 10);
      var val = parseInt(input.value || '0', 10) || 0;
      val = minus ? Math.max(min, val - 1) : val + 1;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Cart page: submit the form when a quantity changes
    var cartForm = document.querySelector('[data-auto-submit-qty]');
    if (cartForm) {
      var timer;
      cartForm.addEventListener('change', function (e) {
        if (!e.target.matches('input[name="updates[]"]')) return;
        clearTimeout(timer);
        timer = setTimeout(function () { cartForm.submit(); }, 450);
      });
    }
  }

  /* ---------- Collection filters ---------- */
  function initFilters() {
    var form = document.querySelector('[data-auto-submit]');
    if (!form) return;
    var timer;
    form.addEventListener('change', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 350);
    });
    // Close the filter panel when clicking elsewhere
    document.addEventListener('click', function (e) {
      var panel = document.querySelector('[data-filter-panel]');
      if (panel && panel.open && !panel.contains(e.target)) panel.open = false;
    });
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    var root = document.querySelector('[data-product-root]');
    if (!root) return;
    var variants = [];
    try {
      var json = root.querySelector('[data-variants-json]');
      variants = JSON.parse(json.textContent);
    } catch (err) { return; }

    var picker = root.querySelector('[data-variant-picker]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var gallery = root.querySelector('[data-gallery]');

    function showImage(id) {
      if (!gallery || !id) return;
      var slides = gallery.querySelectorAll('.gallery-slide');
      var thumbs = gallery.querySelectorAll('[data-thumb]');
      var found = false;
      slides.forEach(function (s) {
        var on = s.getAttribute('data-media-id') === String(id);
        if (on) found = true;
      });
      if (!found) return;
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(id)); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id)); });
    }

    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-thumb]');
        if (btn) showImage(btn.getAttribute('data-thumb'));
      });
    }

    function renderPrice(v) {
      if (!priceEl) return;
      priceEl.textContent = '';
      var main = document.createElement('span');
      main.textContent = v.price;
      if (v.compare) {
        main.className = 'price__sale';
        var old = document.createElement('s');
        old.className = 'price__compare';
        old.textContent = v.compare;
        priceEl.appendChild(main);
        priceEl.appendChild(old);
      } else {
        priceEl.appendChild(main);
      }
    }

    function update() {
      if (!picker) return;
      var selected = [];
      picker.querySelectorAll('fieldset.option').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
      renderPrice(match);
      showImage(match.image);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    if (picker) picker.addEventListener('change', update);
  }

  /* ---------- Related products (async recommendations) ---------- */
  function initRecommendations() {
    var holder = document.querySelector('[data-recommendations-url]');
    if (!holder || !window.fetch) return;
    var wrapper = holder.closest('.shopify-section');
    fetch(holder.getAttribute('data-recommendations-url'))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || !wrapper) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('.shopify-section') || tmp;
        var hasProducts = inner.querySelector('.product-card');
        if (!hasProducts) return;
        wrapper.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  function init() {
    initMenu();
    initCarousels();
    initQuantity();
    initFilters();
    initProduct();
    initRecommendations();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-init inside the theme editor when sections reload
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });
})();
